import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Tab, Tabs, Grid, Typography, Table, TableHead, TableRow, TableCell, TableBody, Icon, Divider, TextField, Button } from '@material-ui/core';
import * as Actions from './store/actions';
import RichTextEditor from 'react-rte';
import * as AssetActions from '../asset/store/actions';
import * as moment from 'moment';

const styles = theme => ({
    layoutRoot   : {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot     : {
        height: 64
    },
    tabRoot      : {
        height: 64
    },

    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
});

class AssignmentGrader extends Component {
    state = {
        current_tab:           0,
        student_assignment_id: 0,
    }

    constructor(props) {
        super(props);

        const student_assignment_id = this.props.match.params.student_assignment_id;
        const auth_id               = this.props.auth.user.data.auth_id;

        this.state = {
            ...this.state,
            student_assignment_id: student_assignment_id,
        }

        this.props.updateAssignmentLoaded(false);
        this.props.getAssignmentByStudentAssignmentID(student_assignment_id);
    }

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        });
    }

    handleChange = field_name => event => {
        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }

        this.props.updateStudentAssignment(update_data);
    }

    handleBlur = (field_name) => (event) => {
        const { updateStudentAssignment } = this.props;
        let new_value = event.target.value;

        if (isNaN(new_value)) {
            new_value = Number(0);
        } else {
            new_value = Math.abs(Number(new_value));
        }

        const update_data = {
            [field_name]: new_value
        }
        updateStudentAssignment(update_data);
    }

    handleSubmit = () => {
        const auth_id = this.props.auth.user.data.auth_id;

        this.props.gradeStudentAssignment(this.props.studentAssignment.header, this.props.auth.user.data.auth_id, true);
    }

    getPageContent = (current_tab) => {
        const { currentAssignment, studentAssignment, currentStudent } = this.props;
        switch(current_tab)
        {
            case(0): // Grade
            {
                return (
                    <Grid container spacin={24}>
                        <Grid item xs={12}>
                            <TextField
                                id="StudentName"
                                label="Student Name"
                                value={currentStudent.FirstName + " " + currentStudent.LastName}
                                margin="normal"
                                variant="outlined"
                                disabled={true}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="Score"
                                label="Score"
                                value={studentAssignment.header.Score}
                                margin="normal"
                                variant="outlined"
                                onBlur={this.handleBlur('Score')}
                                onChange={this.handleChange('Score')}
                                type='number'
                                inputProps={{
                                    min: 0.00,
                                    step: 1
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                onClick={this.handleSubmit}
                            >
                                Save
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => this.props.history.goBack()}
                            >
                                Back
                            </Button>
                        </Grid>
                    </Grid>
                )
            }
            case(1): // Detail
            {
                return (
                    <Grid container spacing={24}>
                        <Grid item xs={12}>
                            <Typography variant="h5">{currentAssignment.header.AssignmentName}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <RichTextEditor
                                value    = {RichTextEditor.createValueFromString((currentAssignment.header.AssignmentDescription || ''), 'html')}
                                onChange = {this.onEditorStateChange}
                                readOnly = {true}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body1">Instructor Attachments</Typography>
                            <Divider />
                            {currentAssignment.assetList.map((asset) => {
                                return (
                                    <li key={asset.header.asset_id}><a href={asset.header.URL} target="_blank">{asset.header.AssetNewName}</a></li>
                                );
                            })}
                        </Grid>
                    </Grid>
                );
            }
            case(2): // File List
            {
                return (
                    <Grid container spacing={24}>
                        <Grid item xs={12}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>File Name</TableCell>
                                        <TableCell>Upload Date</TableCell>
                                        <TableCell>Download</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {studentAssignment.assetList.map((asset) => {
                                        return (
                                            <TableRow key={asset.header.asset_id}>
                                                <TableCell>{asset.header.AssetName}</TableCell>
                                                <TableCell>{moment(asset.header.CreationDate).format("MM-DD-YYYY hh:mm:ss")}</TableCell>
                                                <TableCell><a href={asset.header.URL} target="_blank"><Icon>cloud_download</Icon></a></TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </Grid>
                    </Grid>
                );
            }
        }
    }

    getButtonContent = () => {

    }

    render() {
        const { classes, isStudentAssignmentLoaded, studentAssignment } = this.props;
        const { current_tab } = this.state;

        const button_content = this.getButtonContent();
        let page_content = <React.Fragment>Loading...</React.Fragment>;
        if(isStudentAssignmentLoaded) {
            page_content = this.getPageContent(current_tab);
        }

        return (
            <FusePageCarded
                classes={{
                    root:    classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <div className="py-24"><h4>{'Grade Assignment'}</h4></div>
                }
                contentToolbar={
                    <Tabs
                        value={current_tab}
                        onChange={this.handleChangeTab}
                        indicatorColor="primary"
                        textColor="primary"
                        classes={{
                            root: classes.tabsRoot
                        }}
                    >
                        <Tab
                            classes={{
                                root: classes.tabRoot
                            }}
                            label="Grade"
                        />
                        <Tab
                            classes={{
                                root: classes.tabRoot
                            }}
                            label="Assignment Detail"
                        />
                        <Tab
                            classes={{
                                root: classes.tabRoot
                            }}
                            label="Student Uploads"
                        />
                    </Tabs>
                }
                content={
                    <React.Fragment>
                        <div className="p-24">
                            {page_content}
                        </div>
                        <div className="p-24">
                            {button_content}
                        </div>
                    </React.Fragment>
                }
            />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getAssignment:                       Actions.getAssignment,
        updateAssignmentLoaded:              Actions.updateAssignmentLoaded,
        getAssignmentData:                   Actions.getAssignmentData,
        getStudentAssignment:                Actions.getStudentAssignment,
        getAssignmentByStudentAssignmentID:  Actions.getAssignmentByStudentAssignmentID,
        updateStudentAssignment:             Actions.updateStudentAssignment,
        gradeStudentAssignment:              Actions.gradeStudentAssignment,
        getModelAssetList:                   AssetActions.getModelAssetList,
    }, dispatch);
}

function mapStateToProps({ assignmentApp, assetApp, auth }) {
    return {
        isAssignmentLoaded:            assignmentApp.assignments.isAssignmentLoaded,
        currentAssignment:             assignmentApp.assignments.currentAssignment,
        studentAssignment:             assignmentApp.student_assignment.studentAssignment,
        isStudentAssignmentLoaded:     assignmentApp.student_assignment.isStudentAssignmentLoaded,
        currentStudent:                assignmentApp.student_assignment.currentStudent,
        assetList:                     assetApp.assets.assetList,
        fileList:                      assetApp.assets.fileList,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AssignmentGrader)));



// WEBPACK FOOTER //
// src/main/content/assignment/AssignmentGrader.js